import { Point, Rectangle, Vector } from "../../../../domain/drawing";
import { DragKinds } from "../../DragKinds";
import { ITransformable } from "../ITransformable";
import { AbstractTransformer } from "./AbstractTransformer";

export class CenterFixedTransformer extends AbstractTransformer {
  constructor(private readonly _transformer: ITransformable) {
    super();
  }

  transformRectangle(source: Rectangle, pointer: Point, kind: DragKinds): Rectangle {
    const transformed = this._transformer.transformRectangle(source, pointer, kind);
    this.adjustVertical(source, transformed);
    this.adjustHorizontal(source, transformed);
    return transformed;
  }

  private adjustVertical(source: Rectangle, transformed: Rectangle) {
    const height = Math.max(transformed.size.height * 2 - source.size.height, 10);
    transformed.topLeft.y += (source.center.y - transformed.topLeft.y) - (height / 2);
    transformed.size.height = height;
  }

  private adjustHorizontal(source: Rectangle, transformed: Rectangle) {
    const width = Math.max(transformed.size.width * 2 - source.size.width, 10);
    transformed.topLeft.x += (source.center.x - transformed.topLeft.x) - (width / 2);
    transformed.size.width = width;
  }

  transformVector(source: Vector, pointer: Point, kind: DragKinds): Vector {
    const transformed = this._transformer.transformVector(source, pointer, kind);
    if (this.isMovingFrom(kind)) {
      this.adjustFrom(source, transformed);
    } else if (this.isMovingTo(kind)) {
      this.adjustTo(source, transformed);
    }
    return transformed;
  }

  private adjustFrom(source: Vector, transformed: Vector) {
    const vector = new Vector(source.from, transformed.from);
    transformed.to = transformed.to.add(vector.difference.reverse());
  }

  private adjustTo(source: Vector, transformed: Vector) {
    const vector = new Vector(source.to, transformed.to);
    transformed.from = transformed.from.add(vector.difference.reverse());
  }
}
